const MESSENGER_WAIT_MS = 2500;
const MESSENGER_SECOND_CHANCE_WAIT_MS = 1000;
const MESSENGER_WAIT_AFTER_HEAL_MS = 3000;
const HEAL_COOLDOWN_MS = 5 * 60 * 1000;
export const makeSupportClickRecovery = (param)=>{
    let { env, requestHeal, canHeal, reopenMessenger, isWidgetLoaded, getUserId } = param;
    const state = {
        ladderInFlight: false,
        lastHealAtMs: undefined
    };
    const isHealAllowed = ()=>{
        if (!canHeal()) {
            return false;
        }
        const probe = env.probeDom();
        if (probe.messengerOpen || probe.launcherPresent) {
            return false;
        }
        return state.lastHealAtMs == null || env.now() - state.lastHealAtMs >= HEAL_COOLDOWN_MS;
    };
    const runLadder = async ()=>{
        const startedAtMs = env.now();
        const visibilityAtClick = env.getVisibility();
        const pathname = env.getPathname();
        const report = (param)=>{
            let { outcome, messengerOpened, healAttempted } = param;
            const probe = env.probeDom();
            env.logBIEvent({
                type: 'transaction',
                transaction_name: 'intercom_show_message',
                status: 'end',
                outcome,
                page_name: 'intercom',
                hierarchy: [],
                user_id: getUserId(),
                pathname,
                messenger_frame_present: messengerOpened || probe.messengerOpen,
                launcher_present: probe.launcherPresent,
                bootstrap_frame_present: probe.bootstrapFramePresent,
                visibility_at_load: env.getVisibilityAtLoad(),
                visibility_at_click: visibilityAtClick,
                heal_attempted: healAttempted,
                elapsed_ms: env.now() - startedAtMs
            });
        };
        const openFallback = (healAttempted)=>{
            report({
                outcome: 'fallback_opened',
                messengerOpened: false,
                healAttempted
            });
            if (isWidgetLoaded()) {
                env.openFallbackSupport();
            }
        };
        if (visibilityAtClick === 'hidden') {
            return;
        }
        const firstWait = await env.waitForMessenger(MESSENGER_WAIT_MS);
        if (firstWait.wentHidden) {
            return;
        }
        if (firstWait.opened) {
            report({
                outcome: 'messenger_opened',
                messengerOpened: true,
                healAttempted: false
            });
            return;
        }
        let healedThisClick = false;
        if (isHealAllowed()) {
            state.lastHealAtMs = env.now();
            healedThisClick = true;
            try {
                await requestHeal();
            } catch (unused) {
                openFallback(true);
                return;
            }
            reopenMessenger();
        }
        const secondWait = await env.waitForMessenger(healedThisClick ? MESSENGER_WAIT_AFTER_HEAL_MS : MESSENGER_SECOND_CHANCE_WAIT_MS);
        if (secondWait.wentHidden) {
            return;
        }
        if (secondWait.opened) {
            report({
                outcome: healedThisClick ? 'healed_then_opened' : 'messenger_opened',
                messengerOpened: true,
                healAttempted: healedThisClick
            });
            return;
        }
        openFallback(healedThisClick);
    };
    return {
        observeClick: ()=>{
            if (state.ladderInFlight) {
                return;
            }
            state.ladderInFlight = true;
            void runLadder().finally(()=>{
                state.ladderInFlight = false;
            });
        }
    };
};
